import React, { useEffect, useState } from 'react';
import { CheckCircle2Icon, XIcon } from 'lucide-react';
type Buyer = {
  name: string;
  place: string;
  ago: string;
};
const BUYERS: Buyer[] = [{
  name: 'Carlos M.',
  place: 'Monterrey, Mexico',
  ago: '2 minutes ago'
}, {
  name: 'Andrés P.',
  place: 'Medellín, Colombia',
  ago: '4 minutes ago'
}, {
  name: 'Javier R.',
  place: 'Buenos Aires, Argentina',
  ago: '6 minutes ago'
}, {
  name: 'Luis F.',
  place: 'Santiago, Chile',
  ago: '3 minutes ago'
}, {
  name: 'Miguel A.',
  place: 'Lima, Peru',
  ago: '8 minutes ago'
}, {
  name: 'Rubén C.',
  place: 'Guayaquil, Ecuador',
  ago: '5 minutes ago'
}, {
  name: 'Diego S.',
  place: 'Madrid, Spain',
  ago: '9 minutes ago'
}, {
  name: 'Héctor G.',
  place: 'San José, Costa Rica',
  ago: '7 minutes ago'
}, {
  name: 'Marcos V.',
  place: 'Montevideo, Uruguay',
  ago: '11 minutes ago'
}, {
  name: 'Julián T.',
  place: 'Guadalajara, Mexico',
  ago: '1 minute ago'
}];
export function PurchasePopup() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let timeoutId: number;
    const show = () => {
      setVisible(true);
      timeoutId = window.setTimeout(() => {
        setVisible(false);
        setIndex(i => (i + 1) % BUYERS.length);
      }, 5200);
    };
    const firstId = window.setTimeout(show, 7000);
    const cycleId = window.setInterval(show, 16000);
    return () => {
      window.clearTimeout(firstId);
      window.clearTimeout(timeoutId);
      window.clearInterval(cycleId);
    };
  }, [dismissed]);
  if (dismissed) return null;
  const buyer = BUYERS[index];
  return <div aria-live="polite" className={`fixed left-3 top-3 z-50 max-w-[320px] transition-[opacity,transform] duration-200 ease-out sm:left-5 sm:top-5 ${visible ? 'translate-y-0 opacity-100' : 'pointer-events-none -translate-y-3 opacity-0'}`} data-id="element-36" data-mp="s67w9w8pdf32">
      <div className="flex items-start gap-3 rounded-xl border border-ink-500 bg-ink-800 p-3 pr-8 shadow-2xl" data-id="element-37" data-mp="23nhao4cz5gxi">
        <span className="mt-0.5 flex h-8 w-8 shrink-0 items-center justify-center rounded-full bg-flame-500/15" data-id="element-38" data-mp="2aqxoiw7y6wiy">
          <CheckCircle2Icon className="h-5 w-5 text-flame-400" aria-hidden="true" data-id="element-39" data-mp="2kn0nxubf0h27" />
        </span>
        <div className="min-w-0" data-id="element-40" data-mp="2plkb1y1qvyw5">
          <p className="text-sm font-semibold leading-snug text-white" data-id="element-41" data-mp="2pksm362nkzeu">
            {buyer.name} just bought the Weld Decision System™
          </p>
          <p className="mt-0.5 text-xs text-zinc-400" data-id="element-42" data-mp="1rw8wtb97iilq">
            {buyer.place} · {buyer.ago}
          </p>
        </div>
        <button type="button" onClick={() => setDismissed(true)} aria-label="Dismiss notification" className="absolute right-1.5 top-1.5 rounded p-1 text-zinc-500 transition-colors duration-150 ease-out hover:text-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-spark" data-id="element-43" data-mp="21vpyzip92ecy">
          <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-44" data-mp="1e53yqdlhlydi" />
        </button>
      </div>
    </div>;
}